@if (Vendor && LoggedInUser) {
  <div class="container-fluid">
    <div class="row row-padding">
      <div class="col">
        <label class="title-label">Admin</label>
      </div>
    </div>
    @if (LoggedInUser.UserAccountType?.name === 'Client') {
      <div class="row row-padding">
        <div class="col"></div>
        <div class="col-auto">
          <button class="btn btn-primary" (click)="inviteVendor()">
            Invite vendor
          </button>
        </div>
      </div>
    }
    <div class="row row-padding">
      <div class="col-md-12">
        <app-display-card>
          <div class="row">
            <div class="col">
              <label class="section-label">Vendor Information</label>
            </div>
          </div>
          <div class="inner-panel rounded">
            <div class="row business-info-container g-0">
              <div class="col-md-6">
                <div class="row g-0">
                  <div class="col-md-4"><label>Legal Name:</label></div>
                  <div class="col-md-6">
                    <label class="content-label">{{ Vendor.legalName }}</label>
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-4">
                    <label>{{ localizationInfo.dba.label }}:</label>
                  </div>
                  <div class="col-md-6">
                    <label class="content-label">{{ Vendor.dba }}</label>
                  </div>
                </div>
                @if (Vendor.website) {
                  <div class="row g-0">
                    <div class="col-md-4"><label>Website:</label></div>
                    <div class="col-md-6">
                      <label class="content-label">
                        <a
                          [href]="Vendor.website"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ Vendor.website }}</a
                        >
                      </label>
                    </div>
                  </div>
                }
                <div class="row g-0">
                  <div class="col-md-4"><label>Office Phone:</label></div>
                  <div class="col-md-6">
                    <label class="content-label"
                      >{{ Vendor.phoneExt }} {{ Vendor.phone }}</label
                    >
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-4"><label>Tax Structure:</label></div>
                  <div class="col-md-6">
                    <label class="content-label">{{
                      Vendor.companyType
                    }}</label>
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-4">
                    @if (Vendor.country === 'US') {
                      <label>{{ Vendor.ein ? 'EIN' : 'SSN' }}:</label>
                    }
                    @if (Vendor.country === 'CA') {
                      <label
                        >{{
                          localizationInfo.taxId('gst-hst').label
                        }}
                        Number:</label
                      >
                    }
                  </div>
                  <div class="col-md-6">
                    @if (Vendor.country === 'US') {
                      <label class="content-label">{{
                        Vendor.ein ? Vendor.ein : Vendor.ssn
                      }}</label>
                    }
                    @if (Vendor.country === 'CA') {
                      <label class="content-label">{{ Vendor.bsn }}</label>
                    }
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-6">
                    <label>Number of Employees:</label>
                  </div>
                  <div class="col-md-6">
                    <label class="content-label">{{
                      getNumberOfEmployeesLabel(Vendor.qtyEmployees!)
                    }}</label>
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-6">
                    <label>Employ Sub-Contractors?:</label>
                  </div>
                  <div class="col-md-6">
                    <label class="content-label">{{
                      Vendor.employsSubContractors ? 'YES' : 'NO'
                    }}</label>
                  </div>
                </div>
                <div class="row g-0">
                  <div class="col-md-6">
                    <label>Offer After-Hours Service?:</label>
                  </div>
                  <div class="col-md-6">
                    <label class="content-label">{{
                      Vendor.allowAfterHoursService ? 'YES' : 'NO'
                    }}</label>
                  </div>
                </div>
                @if (Vendor.country === 'US') {
                  <div class="row g-0">
                    <div class="col-md-6"><label>Publicly Traded?</label></div>
                    <div class="col-md-6">
                      <label class="content-label">{{
                        Vendor.isPubliclyTraded ? 'YES' : 'NO'
                      }}</label>
                    </div>
                  </div>
                }
                <div class="row g-0">
                  <div class="col-md-6">
                    <label>Small Business / Minority Owned:</label>
                  </div>
                  <div class="col-md-6">
                    <label class="content-label">{{
                      smallBusinessOptionsConcatenated
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row row-padding-bottom">
                  <div class="col centered">
                    <div class="row">
                      <div class="col">
                        @if (
                          VendorFormGroup.controls['logo'].value || logoUrl
                        ) {
                          <img
                            class="img-fluid profile-image-container"
                            alt="logo"
                            [src]="
                              logoUrl ?? VendorFormGroup.controls['logo'].value
                            "
                          />
                        }
                      </div>
                    </div>
                    @if (LoggedInUser.UserAccountType?.name === 'Vendor') {
                      <div class="row row-padding-top">
                        <div class="col">
                          <button class="btn btn-primary" (click)="logoClick()">
                            {{
                              Vendor.logo || Vendor.LogoFileId
                                ? 'Update'
                                : 'Add'
                            }}
                            Logo
                          </button>
                          <input
                            #logoInput
                            type="file"
                            (change)="logoSelection($event)"
                            hidden
                          />
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>
    @if (MailingAddress || StreetAddress || RemitToAddress) {
      <div class="row row-padding">
        <div class="col-md-12">
          <app-display-card>
            <div class="row">
              <div class="col">
                <label class="section-label">Address Information</label>
              </div>
              <div class="col"></div>
              @if (LoggedInUser.UserAccountType?.name !== 'Client') {
                <div class="col-auto">
                  <button class="btn btn-primary" (click)="editAddresses()">
                    Edit
                  </button>
                </div>
              }
            </div>
            <div class="inner-panel rounded">
              <div class="row address-info-container">
                @if (MailingAddress) {
                  <div class="col-md-4">
                    <div class="row g-0">
                      <div class="col-md-5">
                        <label>Mailing Address:</label>
                      </div>
                      <div class="col-md-7">
                        <label class="content-label"
                          >{{ MailingAddress.address1 }}
                          {{ MailingAddress.address2 }}
                          {{ MailingAddress.city }}, {{ MailingAddress.state }}
                          {{ MailingAddress.zip }}</label
                        >
                      </div>
                    </div>
                  </div>
                }
                @if (StreetAddress) {
                  <div class="col-md-4">
                    <div class="row g-0">
                      <div class="col-md-5"><label>Street Address:</label></div>
                      <div class="col-md-7">
                        <label class="content-label"
                          >{{ StreetAddress.address1 }}
                          {{ StreetAddress.address2 }} {{ StreetAddress.city }},
                          {{ StreetAddress.state }}
                          {{ StreetAddress.zip }}</label
                        >
                      </div>
                    </div>
                  </div>
                }
                @if (RemitToAddress) {
                  <div class="col-md-4">
                    <div class="row g-0">
                      <div class="col-md-5">
                        <label>Remit-to Address:</label>
                      </div>
                      <div class="col-md-7">
                        <label class="content-label"
                          >{{ RemitToAddress.address1 }}
                          {{ RemitToAddress.address2 }}
                          {{ RemitToAddress.city }}, {{ RemitToAddress.state }}
                          {{ RemitToAddress.zip }}</label
                        >
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </app-display-card>
        </div>
      </div>
    }
    @if (MailingAddress && Vendor.serviceArea) {
      <div class="row row-padding">
        <div class="col-md-12">
          <app-display-card>
            <div class="row">
              <div class="col">
                <label class="section-label">Trade Information</label>
              </div>
            </div>
            <div class="inner-panel rounded">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <label>Max Service Distance:</label>
                    </div>
                    <div class="col-md-6">
                      <label class="content-label">{{
                        Vendor.serviceArea
                      }}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label
                        >{{
                          localizationInfo.territoryPlural.label
                        }}
                        Serviced:</label
                      >
                    </div>
                    <div class="col-md-6">
                      <label class="content-label">{{
                        vendorTradeStatesConcatenated
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6"><label>Trades:</label></div>
                    <div class="col-md-6">
                      <label class="content-label">{{
                        tradesConcatenated
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-display-card>
        </div>
      </div>
    }
    <!-- Hiding Licenses sections because only approved vendors will appear in Find a Vendor -->
    <!-- @if (isLicenseRequirements()) {
      <div class="row row-padding">
        <div class="col-md-12">
          <app-display-card>
            <div class="row">
              <div class="col">
                <label class="section-label">Licenses</label>
              </div>
            </div>
            <div class="row">
              @for (
                element of stateToLicenseCompletionMap | keyvalue;
                track element
              ) {
                <div class="col-md-3">
                  <div class="inner-panel rounded">
                    <div class="centered license">
                      <div class="row">
                        <label
                          class="license-state-name"
                          [ngClass]="{
                            'success-green': element.value,
                            'error-red': !element.value
                          }"
                          >{{ element.key }}</label
                        >
                      </div>
                      <div class="row">
                        @if (element.value) {
                          <img
                            src="assets/images/vive-icon-green.svg"
                            class="brand-check"
                            alt="Yes"
                          />
                        }
                        @if (!element.value) {
                          <i class="bi bi-x-lg error-red"></i>
                        }
                      </div>
                    </div>
                    <button
                      class="btn btn-primary"
                      (click)="downloadLicenseFile(element)"
                    >
                      Download License
                    </button>
                  </div>
                </div>
              }
            </div>
          </app-display-card>
        </div>
      </div>
    } -->
    <!--
                        <div class="row row-padding" *ngIf="Owners.length > 0 && LoggedInUser.UserAccountType?.name === 'Vendor'">
                          <div class="col-md-12">
                            <app-display-card>
                              <div class="row">
                                <div class="col">
                                  <label class="section-label">Owners</label>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-4" *ngFor="let Owner of Owners;">
                                  <div class="inner-panel rounded">
                                    <div class="row">
                                      <div class="col-md-6"><label>Name:</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.firstName }} {{ Owner.lastName }}</label></div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6"><label>Phone:</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.phone }}</label></div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6"><label>DOB:</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.dob | date : 'MM/dd/YYYY' }}</label></div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6"><label>State:</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.Address?.state }}</label></div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6"><label>{{ localizationInfo.socialSecurity.label }} # (1st 5):</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.ssn }}</label></div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6"><label>Ownership %:</label></div>
                                      <div class="col-md-6"><label class="content-label">{{ Owner.percentOwner }}</label></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </app-display-card>
                          </div>
                        </div>
                        -->
    @if (
      LoggedInUser.UserAccountType?.name === 'Vendor' &&
      InsuranceAgents.length > 0
    ) {
      <div class="row row-padding">
        <div class="col-md-12">
          <app-display-card>
            <div class="row">
              <div class="col">
                <label class="section-label">Insurance Agents</label>
              </div>
            </div>
            <div class="row">
              @for (agent of InsuranceAgents; track agent) {
                <div class="col-lg-6 py-2">
                  <div class="inner-panel rounded h-100">
                    <div class="row">
                      <div class="row">
                        <div class="col-12 col-xl-5">
                          <label>Agency Name:</label>
                        </div>
                        <div class="col-12 col-xl-7">
                          <label class="content-label">{{
                            agent.agencyName
                          }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-xl-5">
                          <label>Agent Name:</label>
                        </div>
                        <div class="col-12 col-xl-7">
                          <label class="content-label"
                            >{{ agent.firstName }} {{ agent.lastName }}</label
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-xl-5"><label>Phone:</label></div>
                        <div class="col-12 col-xl-7">
                          <label class="content-label">{{
                            agent.phone1
                          }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-xl-5"><label>Ext:</label></div>
                        <div class="col-12 col-xl-7">
                          <label class="content-label">{{
                            agent.phone1Ext
                          }}</label>
                        </div>
                      </div>
                      @if (agent.email) {
                        <div class="row">
                          <div class="col-12 col-xl-5">
                            <label>Email:</label>
                          </div>
                          <div class="col-12 col-xl-7">
                            <app-email-container
                              [email]="agent.email"
                            ></app-email-container>
                          </div>
                        </div>
                      }
                      <div class="row">
                        <div class="col-12 col-xl-5">
                          <label>Policies Handled:</label>
                        </div>
                        <div class="col-12 col-xl-7">
                          <label class="content-label">{{
                            generateHandledPoliciesText(agent)
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </app-display-card>
        </div>
      </div>
    }
  </div>
}
